import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useOutletContext } from "react-router";
import Button from "../../../components/Common/Button/Button";
import MainLayout from "../../../components/Common/MainLayout/MainLayout";
import Dropdown from "../../../components/Common/ReactForm/Dropdown/Dropdown";
import {
  getClassesWithSurveryActionHandler,
  getScoredSurveyReportActionHandler,
  getSurveyReportActionHandler,
} from "../../../store/actions/actionHandlers/reportActionHandler";

import { surveyReportNav } from "../../../utils/mainTabs/reports/surveyReportNav";
import classes from "./SurveyReportPage.module.scss";
import { setErrorAction } from "../../../store/actions/actionCreators/errorActionCreator";

import ReportGraph from "../ReportGraph/ReportGraph";
import DownloadIconSmall from "../../../components/Common/SvgIcons/CommonIcons/DownloadIconSmall";
import { FormattedMessage, injectIntl } from "react-intl";
import Loader from "../../../components/Common/Loader/Loader";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import InputHookForm from "../../../components/Common/Input/Input";
import { FormProvider, useForm } from "react-hook-form";
import RadioGroup from "../../../components/Common/RadioGroup/RadioGroup";
import { setErrorHandler } from "../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../utils/errorTypes";

const SurveyReportPage = ({ intl }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { navLinks, tiles } = surveyReportNav;
  const reportState = useSelector((state) => state.reportReducer);
  const { classWithSurvey, surveyReport, classWithScoredSurvey } = reportState;
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedClassName, setSelectedClassName] = useState("");
  const [selectedClassScoredSurveyId, setSelectedClassScoredSurveyId] =
    useState("");
  const [classWithSurveyOptions, setClassWithSurveyOptions] = useState([]);
  const reportMode = "View";
  const { tenantName } = useOutletContext();
  const [surveyData, setSurveyData] = useState([]);
  const [reportLoader, setReportLoader] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [classSurvey, setClassSurvey] = useState([]);
  const [surveyType, setSurveyType] = useState("basic");
  const [manageSurveyTiles, setManageSurveyTiles] = useState([]);

  const surveySegregation = (surveyClass) => {
    return surveyClass?.map((d) => ({
      label: d.Name,
      value: d.Id,
    }));
  };

  useEffect(() => {
    const classOptions = surveySegregation(classWithSurvey);
    setClassWithSurveyOptions(classOptions);
  }, [classWithSurvey]);

  useEffect(() => {
    dispatch(getClassesWithSurveryActionHandler());
    dispatch(getScoredSurveyReportActionHandler(true));
  }, [dispatch]);

  const handleSearch = () => {
    if (selectedClass) {
      setIsClicked(true);
      setSurveyData([]);
      dispatch(getSurveyReportActionHandler(selectedClass, reportMode)).then(
        (response) => {
          setReportLoader(true);
          if (response.status === 200) {
            setReportLoader(false);
            if (surveyType === "scored")
              setSelectedClassScoredSurveyId(response.data?.SurveyId);
            response?.data?.Questions?.forEach((e) => {
              if (e.QuestionType === 1) {
                setSurveyData((prevState) => [
                  ...prevState,
                  {
                    labels: e?.Choices?.map((f) => f.Text),
                    datasets: [
                      {
                        data: e?.Choices?.map((f) => f.Percentage),
                        backgroundColor: ["red"],
                      },
                    ],
                  },
                ]);
              } else if (e.QuestionType === 2) {
                setSurveyData((prevState) => [
                  ...prevState,
                  {
                    labels: e?.Choices?.map((f) => f.Text),
                    datasets: [
                      {
                        data: e?.Choices?.map((f) => f.Percentage),
                        backgroundColor: ["#e6550d", "#8a3392"],
                      },
                    ],
                  },
                ]);
              } else setSurveyData((prevState) => [...prevState, {}]);
            });
          }
        }
      );
    } else {
      dispatch(setErrorAction("WARN", "Select a class"));
    }
  };

  let isMandatory;

  if (surveyReport?.IsMandatory === true) {
    isMandatory = "Yes";
  } else {
    isMandatory = "No";
  }

  let queType2Data = [];
  let queType1Data = [];
  surveyReport?.Questions?.map((e) =>
    e.QuestionType === 2
      ? e.Choices?.map((f) => queType2Data.push(f.Percentage))
      : e.QuestionType === 1
      ? e.Choices?.map((f) => queType1Data.push(f.Percentage))
      : ""
  );

  let queType1 = [];
  let queType2 = [];

  const reportData = surveyReport?.Questions?.map((e) => {
    if (e.QuestionType === 1) e?.Choices?.map((f) => queType1.push(f.Text));
    if (e.QuestionType === 2) e?.Choices?.map((f) => queType2.push(f.Text));
  });

  const handleReset = () => {
    setIsClicked(false);
    setSelectedClass([]);
    reset();
  };
  var totalPercentage = queType2Data.reduce(function (x, y) {
    return x + y;
  }, 0);

  const onDownload = () => {
    if (surveyType === "basic")
      dispatch(
        getSurveyReportActionHandler(
          selectedClass,
          "Extract",
          selectedClassName
        )
      );
    else
      dispatch(
        getSurveyReportActionHandler(
          selectedClass,
          "Extract",
          selectedClassName,
          "UserScoredSurveyReport",
          selectedClassScoredSurveyId
        )
      );
  };

  const methods = useForm({
    mode: "onChange",
  });
  const {
    formState: { errors },
    reset,
    getValues,
    setValue,
  } = methods;

  useEffect(() => {
    if (classWithSurveyOptions?.length > 0) {
      let sortedClassWithSurvey = classWithSurveyOptions.sort((a, b) =>
        a.label > b.label ? 1 : b.label > a.label ? -1 : 0
      );
      const updatedTrainingTypes = sortedClassWithSurvey?.map(
        (trainingType) => {
          return { ...trainingType, isVisible: true };
        }
      );
      setClassSurvey(updatedTrainingTypes);
    }
    if (surveyType === "scored") {
      setManageSurveyTiles(
        tiles(
          navigate,
          "Active",
          "No",
          surveyReport?.ParticipationPercent,
          isMandatory,
          surveyReport?.DistributionUserCount,
          surveyReport?.UserSurveyAttemptCount,
          surveyReport?.Questions?.length,
          surveyReport?.QualitativeQuestionCount
        ).filter((tile) => {
          if (tile.key !== 8) {
            return tile;
          }
        })
      );
    } else {
      setManageSurveyTiles(
        tiles(
          navigate,
          "Active",
          "No",
          surveyReport?.ParticipationPercent,
          isMandatory,
          surveyReport?.DistributionUserCount,
          surveyReport?.UserSurveyAttemptCount,
          surveyReport?.Questions?.length,
          surveyReport?.QualitativeQuestionCount
        )
      );
    }
  }, [classWithSurveyOptions, setClassSurvey, surveyReport, surveyType]);
  const handleclasssurveyoptions = (e) => {
    const detailsData = getValues();
    setSelectedClass(detailsData?.classSurveyOptions[0]?.value);
    const className = classWithSurveyOptions?.find(
      (classObj) =>
        classObj.value.toString() ===
        detailsData?.classSurveyOptions[0]?.value.toString()
    )?.label;
    setSelectedClassName(className);
  };

  const handleSurveyTypeChange = (type) => {
    // setSurveyType(type);
    // let classOptions;
    // if (type === "basic") classOptions = surveySegregation(classWithSurvey);
    // else classOptions = surveySegregation(classWithScoredSurvey);
    // setClassWithSurveyOptions(classOptions);
    // setValue("classSurveyOptions", []);
    setSurveyType(type);

    // ✅ Reset states when changing survey type
    setSelectedClass("");
    setSelectedClassName("");
    setIsClicked(false);
    setSurveyData([]);

    let classOptions;
    if (type === "basic") {
      classOptions = surveySegregation(classWithSurvey);
    } else {
      // ✅ Handle null/empty scored survey data
      if (!classWithScoredSurvey || classWithScoredSurvey.length === 0) {
        classOptions = []; // Set empty array instead of falling back to basic
        dispatch(
          setErrorHandler(errorTypes.FAIL, "No scored surveys available")
        );
      } else {
        classOptions = surveySegregation(classWithScoredSurvey);
      }
    }

    setClassWithSurveyOptions(classOptions);
    setValue("classSurveyOptions", []); // Clear form selection

    // ✅ Update class survey options for the dropdown
    if (classOptions?.length > 0) {
      let sortedClassWithSurvey = classOptions.sort((a, b) =>
        a.label > b.label ? 1 : b.label > a.label ? -1 : 0
      );
      const updatedTrainingTypes = sortedClassWithSurvey?.map(
        (trainingType) => {
          return { ...trainingType, isVisible: true };
        }
      );
      setClassSurvey(updatedTrainingTypes);
    } else {
      // ✅ Set empty array when no options available
      setClassSurvey([]);
    }
  };

  return (
    <>
      <MainLayout navLinks={navLinks(navigate, tenantName)}>
        <div className={classes.reportFilter_Main}>
          <RadioGroup
            label="Survey Type"
            name="surveyTypeRadio"
            options={[
              { value: "basic", label: "Basic Survey" },
              { value: "scored", label: "Scored Survey" },
            ]}
            value={surveyType}
            onChange={handleSurveyTypeChange}
            direction="horizontal"
            className={classes.radioSection}
          />
          <div className={classes.reportFilter_userCLass}>
            <FormProvider {...methods}>
              <InputHookForm
                label={<FormattedMessage id="CLASS_NAME_TEXT" />}
                labelColor="dark"
                name="classSurveyOptions"
                fieldName="label"
                fieldValue="value"
                type="noSearchTags"
                tagType="single"
                buttonLabel={"Select Class"}
                placeholder={intl.formatMessage({
                  id: `REPORT_PLACEHOLDER_CLASSNAME`,
                })}
                required
                searchTagsList={classSurvey}
                handleTagList={(tagsList) => {
                  setClassSurvey(tagsList);
                }}
                height="4"
                searchable={true}
                disabled={false}
                isTagCheckBoxVisible={false}
                addedTagsVisible={false}
                onChange={handleclasssurveyoptions}
                width={"25"}
              />
            </FormProvider>
            <div className={classes.resetSearchBtn}>
              <span
                style={{
                  textDecoration: "underline",
                  color: "#0051BC",
                  cursor: "pointer",
                }}
                onClick={handleReset}
              >
                <FormattedMessage id="RESET_MSG" />
              </span>
              <Button
                label={<FormattedMessage id="P_Search" />}
                dark
                small
                className={classes.searchButton}
                onClick={handleSearch}
                disabled={selectedClass.length == 0}
              />
            </div>
          </div>
        </div>
      </MainLayout>
      {isClicked && (
        <div style={{ position: "relative", zIndex: "1" }}>
          <div>
            <MainLayout tiles={manageSurveyTiles} />
          </div>
          <div className={classes.SurveyReportBar}>
            {surveyReport?.Questions?.map((e, index) => {
              if (e.QuestionType === 1 && e.QuestionType === 2) {
                return (
                  <div className={classes.SurveyReportMain}>
                    <div className={classes.graphicalReport_mainLayout}>
                      <div className={classes.graphicalReport_bar}>
                        <ReportGraph type={"horizontalBar"} />
                      </div>
                      <div className={classes.graphicalReport_bar}>
                        <ReportGraph
                          type={"doughnut"}
                          cutout="20"
                          graphData={surveyData[0]}
                          totalPercentage={totalPercentage}
                          heading={surveyReport?.Questions?.map((e) =>
                            e.QuestionType === 2 ? e.Text : ""
                          )}
                        />
                      </div>
                    </div>
                  </div>
                );
              } else if (e.QuestionType === 2) {
                return (
                  <div className={classes.SurveyReportMain}>
                    {surveyData?.length > 0 && !reportLoader ? (
                      <ReportGraph
                        type={"doughnut"}
                        cutout="20"
                        graphData={surveyData[index]}
                        totalPercentage={totalPercentage}
                        heading={e.Text}
                      />
                    ) : (
                      <div className={classes.reportLoader}>
                        <Loader />
                      </div>
                    )}
                  </div>
                );
              } else if (e.QuestionType === 1) {
                return (
                  <div className={classes.SurveyReportMain}>
                    {surveyData?.length > 0 && !reportLoader ? (
                      <ReportGraph
                        type={"horizontalBar"}
                        graphData={surveyData[index]}
                        totalPercentage={totalPercentage}
                        heading={e?.Text}
                      />
                    ) : (
                      <div className={classes.reportLoader}>
                        <Loader />
                      </div>
                    )}
                  </div>
                );
              } else {
              }
            })}
          </div>
          <div className={classes.dataTable__footer__download}>
            Download Complete Survey Report
            <div
              className={classes.dataTable__footer__download__downloadIcon}
              onClick={onDownload}
            >
              <DownloadIconSmall />
            </div>
            <div
              style={{
                fontWeight: "normal",
                fontSize: "1.5rem",
              }}
            >
              {selectedClassName + ".csv"}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default injectIntl(SurveyReportPage);
